<div class="field row" *ngIf="projected > 0 || current > 0">
    <label class="field-label" for="mileage-penalty" translate="mileagePenaltyLabel"></label>
    <span class="field-data" id="mileage-penalty" *ngIf="current != null && projected == null" [ngClass]="{mileage: alertExists}" 
          translate="currentMileagePenalty" [translateParams]="{amount: current | localeCurrency}" ></span>
    <span class="field-data" id="mileage-penalty" *ngIf="current != null && projected != null" [ngClass]="{mileage: alertExists}"
          translate="currentProjectedMileagePenalty" 
          [translateParams]="{current: current | localeCurrency, projected: projected | localeCurrency}" 
          ></span>
</div>
